import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  Participant,
  ParticipantListRequest,
  ParticipantListResponse,
} from './types'
import { isAllElementsOfSearchTextNotExist } from '../../../../libs/utils'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'client.clientId') {
        return [`client.id`, item[1]?.toLowerCase()]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

export const participantsListMounted = createEvent<ParticipantListRequest>()

export const getParticipants = fx<
  ParticipantListRequest,
  ParticipantListResponse
>({
  method: 'GET',
  url: `/promo/golden_may/participant`,
})

export const $participants = restore<Participant[]>(
  getParticipants.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfParticipants = restore(
  getParticipants.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: participantsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy.includes('country')) {
      orderBy = 'client.country'
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] = `${
            filters[key as keyof typeof filters]
          }`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getParticipants,
})
